export default __webpack_public_path__ + "static/media/cms-lg.710777ca.png";